import { create } from 'zustand';
import { SessionData } from '../types/sessionData';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';

// API
import { getSession } from '../helpers/api/callSession';

type SessionStoreType = {
    session: SessionData;
    loading: boolean;
    setSession: (session: SessionData) => void;
    reloadSession: () => Promise<void>;
    setLoading: (isLoading: boolean) => void;
    clearSession: () => void;
};

const initialSession: SessionData = {
    id: '',
    trainingLabel: '',
    sessionToken: '',
    sessionName: '',
    sessionBegin: '',
    sessionEnd: '',
    nomberDays: 0,
    trainerId: '',
    trainerName: '',
    trainingId: '',
    closingDate: null,
    typeTraining: '',
    societyId: '',
    trainees: [],
    slotsId: []
};

export const useSessionStore = create<SessionStoreType>()(
    devtools(
        persist(
            (set, get) => ({
                session: initialSession,
                loading: false,
                setSession: async (session: SessionData) => {
                    const temporarySession = { ...get().session, ...session };
                    if (session.id) {
                        set({ loading: true });
                        try {
                            const completedSession = await getSession(session.id);
                            set({ session: { ...temporarySession, ...completedSession } });
                        } finally {
                            set({ loading: false });
                        }
                    } else {
                        set({ session: temporarySession });
                    }
                },
                reloadSession: async () => {
                    const { session } = get();
                    if (!session.id) return;

                    set({ loading: true });
                    try {
                        const updatedSession = await getSession(session.id);
                        set({ session: { ...session, ...updatedSession } });
                    } finally {
                        set({ loading: false });
                    }
                },
                setLoading: (isLoading: boolean) => set({ loading: isLoading }),
                clearSession: () => set({ session: initialSession, loading: false })
            }),
            {
                name: 'session',
                storage: createJSONStorage(() => sessionStorage)
            }
        )
    )
);
